export const gamificationOfferDictionary = {
  title: 'Ommaviy oferta',
  approve: 'Tasdiqlayman',
  approvedDate: 'Tasdiqlangan sana: ',
}
